<template>
    <v-layout wrap class="callCard">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
            <div class="callCard__body">
                <div class="callcard__imageWrap">
                    <ResponsiveImage
                        :image-name="dataCallCard.image"
                        class="callCard__image"
                        small-width
                    />
                </div>

                <div class="callCard__info">
                    <p class="h4">{{ dataCallCard.title }}</p>

                    <p>{{ dataCallCard.text }}</p>

                    <ContactCard
                        :consulting-hours="dataCallCard.consultingHours"
                        component-identifier="CallCard"
                        compact
                        rounded
                    />
                </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import ResponsiveImage from '@/components/atoms/image/ResponsiveImage.vue'
import SVGIcon from '@/components/atoms/icons/SVGIcon.vue'
import ContactCard from '@/components/molecules/consultancyCall/phoneContactCard.vue'

import gtmTracking from '@/mixins/gtmTracking'

export default {
    name: 'CallCard',

    components: {
        ResponsiveImage,
        SVGIcon,
        ContactCard,
    },

    mixins: [gtmTracking],

    props: {
        callCard: {
            type: Object,
        },
    },

    data: () => ({
        dataCallCard: {
            title: 'Noch Fragen zur Finanzierung?',
            text:
                'Unser Team ist gerne für Sie da und berät Sie kostenlos zur persönlichen Finanzierung.',
            consultingHours: 'Mo bis Mi: 8-12 Uhr Do bis Fr: 12-15 Uhr',
            callCost: 'Kostenlos',
            image: 'careship/careship-group-photograph',
        },
    }),

    created() {
        this.dataCallCard = Object.assign(this.dataCallCard, this.callCard)
    },
}
</script>

<style lang="stylus">
.callCard {

    &__body {
        display: flex;
        flex-direction: column;

        @media $display-breakpoints.sm-and-up {
            flex-direction: row;
        }
    }

    &__imageWrap {
        height: 100%;
    }

    &__image {
        border-radius: $cs-border-radius;
        height: 200px;
        object-fit: cover;
        width: 100%;

        @media $display-breakpoints.sm-and-up {
            flex: 0 0 auto;
            height: 100%;
            width: 200px;
        }
    }

    .h4 {
        margin: 0 0 $cs-space;
    }

    &__info {
        margin: $cs-space 0 0;

        @media $display-breakpoints.sm-and-up {
            margin: 0 0 0 $cs-spaces.double;
        }
    }

    &__phone {
        align-items: center;
        background: $cs-slate-050;
        border-radius: $cs-border-radius;
        color: $cs-slate-400;
        display: flex;
        font-size: 12px;
        justify-content: center;
        letter-spacing: 0.2px;
        padding: $cs-spaces.half $cs-space;
        text-decoration: none;

        &:hover .icon__phone {
            transform: scale(1.2);
        }
    }

    h6 {
        margin: 0 0 $cs-spaces.half;
        vertical-align: middle;
    }

    .icon__phone {
        flex: 0 0 auto;
        height: 34px;
        margin-right: $cs-space;
        transition: 200ms transform ease-in-out;
        width: 34px;
    }
}
</style>
